<template>
  <div class="title-block">
    <div @click="goback" class="goback1">
      <span class="icon el-icon-arrow-left"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasGoback: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    goback() {
      window.history.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.title-block {
  height: 30px;
  line-height: 30px;
  font-size: 18px;
  .goback1 {
    cursor: pointer;
    span{
      color: #fff;
    }
  }
}
</style>